import {
  Text,
} from '@chakra-ui/react';
import { useUtilityDataSelector } from '../utilities/contexts';
import {IsMobileView} from "../utilities/helpers";

const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const ViewSectionAvailability = (props) => {
  const { profile } = props;
  const { availability } = profile;
  const availabilityLabels = useUtilityDataSelector((utilityData) => utilityData.availability);
  const mobileView = IsMobileView();

  return !availabilityLabels ? null : (
    <div className='relative flex flex-col p-[30px] gap-5 border-[0.5px] border-gray-200 rounded-[20px]'>
      <Text textStyle="h3">My working schedule</Text>

      <div className='grid grid-cols-[150px_1fr]'>
        <div className='flex flex-col gap-2.5 mt-[30px]'>
          {availabilityLabels.map((label, i) => label && label !== '' ? (
              <p className='font-bold text-sm py-1' key={i}>{label}</p>
            ) : null
          )}
        </div>
        <div className='grid grid-cols-7 gap-2.5'>
          {days.map(day => <p key={day} className='text-sm font-bold text-center'>{mobileView ? day[0] : day}</p>)}
          {availability.map((availSet, id) => availSet.map((avail, day) => (
            <p key={`day_${id}_${day}`}
               className={`text-white text-sm ${avail ? 'bg-brand' : 'bg-brand-off'} rounded-[5px] flex justify-center items-center py-1 px-3`}>
              {avail ? '\u2714' : ''}
            </p>
          )))}
        </div>
      </div>
    </div>
  );
};
